import * as React from 'react';
import * as classnames from 'classnames';
import {
    OptionBoxWrapper,
    OptionGroupElement
} from '../../../../common/optionBox';
import Toggle from '../../../../common/Toggle';
import EditorText from '../../../../common/richTextField/EditorText';
import { languageMapping } from '@nexxt/common/constants';

const OptionCardTextImage = (props) => {
    const labelTitle = props.isTypeScale ? 'Scale' : 'Option';
    let optionTextsObject = {};
    const { option, index, optionError } = props;
    (option.texts || []).forEach((text, index) => {
        optionTextsObject[text.language] = { ...text, index };
    });
    const languages = props.languages || props.currentProject.languages || [];
    return (
        <React.Fragment>
            <div
                className={classnames('option-box--image-box', {
                    disabled:
                        !props.editEnabled ||
                        (props.optionSettings &&
                            props.optionSettings.disableImage)
                })}
            >
                {option.mediaURL ? (
                    <img src={option.mediaURL} />
                ) : (
                    <i className="nx nx-image-mb" />
                )}
                <span
                    onClick={() => props.openMediaLibrary(index)}
                    className={classnames('nx-option-edit', {
                        disabled:
                            !props.editEnabled ||
                            (props.optionSettings &&
                                props.optionSettings.disableImage)
                    })}
                >
                    <i className="nx nx-edit"></i>
                </span>
            </div>

            <OptionBoxWrapper>
                {optionError.mediaURL ? (
                    <OptionGroupElement label="" error={optionError.mediaURL}>
                        <span />
                    </OptionGroupElement>
                ) : null}
                <OptionGroupElement
                    label={`${labelTitle} label`}
                    error={optionError.label}
                >
                    <input
                        type="text"
                        placeholder={`${labelTitle} label ${index + 1}`}
                        value={option.label}
                        disabled={
                            !props.editEnabled ||
                            (props.optionSettings &&
                                props.optionSettings.disableLabel)
                        }
                        onChange={(event) => props.handleChange(index, event)}
                        className="form-group__control"
                        name="label"
                        required
                    />
                </OptionGroupElement>
                {languages.map((language, textIndex) => {
                    const text = optionTextsObject[language.value] || {
                        language: language.value,
                        text: '',
                        index: -1
                    };
                    const languageError = (optionError.texts || {})[
                        language.value
                    ];
                    return (
                        <OptionGroupElement
                            key={textIndex}
                            label={
                                <span>
                                    {labelTitle} text{' '}
                                    <i>({languageMapping[text.language]})</i>
                                </span>
                            }
                            error={languageError}
                        >
                            {props.isRichText ? (
                                <EditorText
                                    langName={text.language}
                                    lang={text.langauge}
                                    richTextTranslationChange={(text) =>
                                        props.handleRichText(
                                            index,
                                            text.index,
                                            text,
                                            text.language
                                        )
                                    }
                                    value={null as any}
                                    disabled={!props.editEnabled}
                                />
                            ) : (
                                <input
                                    type="text"
                                    value={text.contents?.[0].text}
                                    onChange={(event) =>
                                        props.handleLanguageChange(
                                            index,
                                            text.index,
                                            event,
                                            text.language
                                        )
                                    }
                                    disabled={!props.editEnabled}
                                    className="form-group__control"
                                    required
                                />
                            )}
                        </OptionGroupElement>
                    );
                })}

                <OptionGroupElement
                    label={`${labelTitle} value`}
                    error={optionError.value}
                >
                    <input
                        type="number"
                        placeholder={`${index + 1}`}
                        value={option.value}
                        onChange={(event) => props.handleChange(index, event)}
                        className="form-group__control"
                        disabled={
                            !props.editEnabled ||
                            (props.optionSettings &&
                                props.optionSettings.disableValue)
                        }
                        name="value"
                        required
                        min="0"
                    />
                </OptionGroupElement>
                {props.showRandomize ? (
                    <OptionGroupElement label="Randomize">
                        <Toggle
                            onChange={(value) =>
                                props.handleToggleValueChange(
                                    index,
                                    'randomizeOption',
                                    value
                                )
                            }
                            disabled={!props.editEnabled}
                            checked={option.randomizeOption}
                        />
                    </OptionGroupElement>
                ) : null}
            </OptionBoxWrapper>
        </React.Fragment>
    );
};

export default OptionCardTextImage;
